import { render, staticRenderFns } from "./BaseTextLabel.vue?vue&type=template&id=05a120e4&"
import script from "./BaseTextLabel.vue?vue&type=script&lang=js&"
export * from "./BaseTextLabel.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports